import Vue from 'vue'
Vue.directive('thousandth', {
  inserted: function (el,binding) {
    if(binding.value){
      let num=binding.value
      num = Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2)
      num = num + '';
      if (!num.includes('.')) {
        num += '.'
      }
      el.innerHTML=num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ',';
      }).replace(/\.$/, '');
    }else {
      el.innerHTML='0'
    }
  }
})
